import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { StudyField } from '@data/study-field/study-field.model';

export interface StudyFieldState
  extends EntityState<StudyField, StudyField['_id']>, ActiveState<StudyField['_id']> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'study-fields', resettable: true, idKey: '_id' })
export class StudyFieldStore extends EntityStore<StudyFieldState> {
  constructor() {
    super();
  }
}
